var map = {
	"./tribe-common.svg": "aacb",
	"./tribe-epic.svg": "5648",
	"./tribe-legendary.svg": "4cc5",
	"./tribe-logo-example.svg": "8e29",
	"./tribe-mythic.svg": "d6f8",
	"./tribe-rare.svg": "9ccf",
	"./tribe-uncommon.svg": "4498"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "97b9";